// extracted by mini-css-extract-plugin
module.exports = {"template-name-clickable":"Campaign_template-name-clickable__1zS7-"};